import { useEffect } from 'react';
import {
    BlockComponent,
    ComponentSettingsManageFilters,
    ContentSettings,
    contentSettingsToComponentProperties,
    ManageFiltersInitialDataResponse,
} from '@report-content';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { reportAPI } from 'api/report';
import useOnMeasurementTime from 'components/report-content/hooks/useOnMeasurementTime';

export function useInitialData(
    contentSettings: ContentSettings,
    component: BlockComponent<ComponentSettingsManageFilters>,
) {
    const queryClient = useQueryClient();
    const initialQueryKey = `report_block_initial_${component.datasetRendererBlockComponentId}`;
    const removeInitialData = () => queryClient.removeQueries({ queryKey: [initialQueryKey] });
    const { data: initialData } = useQuery<ManageFiltersInitialDataResponse, Error>({
        queryKey: [initialQueryKey],
        queryFn: () => {
            return reportAPI.getComponentData(
                component.settings,
                { ...contentSettingsToComponentProperties(contentSettings), page: 0 },
                null,
            );
        },
    });

    useEffect(() => {
        return () => {
            queryClient.removeQueries({ queryKey: ['report_block_initial_-1'] });
            queryClient.removeQueries({ queryKey: [`report_content_editor_${contentSettings.elementId}_instances`] });
            removeInitialData();
        };
    }, []);

    // Full reset on Measurement Interval Change
    useOnMeasurementTime(contentSettings.measurement_time, removeInitialData);
    return { initialData, removeInitialData };
}
